var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2605 0.0419922C3.63907 0.0419922 0.760498 2.84115 0.760498 6.36266C0.760498 9.88418 3.63907 12.6833 7.2605 12.6833C10.8819 12.6833 13.7605 9.88418 13.7605 6.36266C13.7605 2.84115 10.8819 0.0419922 7.2605 0.0419922ZM9.76764 9.523L7.2605 7.08502L4.75336 9.523L4.0105 8.80063L6.51764 6.36266L4.0105 3.92469L4.75336 3.20233L7.2605 5.6403L9.76764 3.20233L10.5105 3.92469L8.00336 6.36266L10.5105 8.80063L9.76764 9.523Z",
    fill: "#B31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.116015c8888e234b083e8897043a5a91.svg";
export { ForwardRef as ReactComponent };